import React from 'react';
import CoveredError from './CoveredError';
import UnknownError from './UnknownError';
import IncorrectTimeError from './IncorrectTimeError';
import TooFarError from 'app/components/search-results/SearchResults/commons/TooFarError';


const SpecificErrorLayout = ({ errorCode, ...props }) => {
  // API error codes
  // https://github.com/mozioinc/mozio/blob/backend-dev/mozio/error_codes.py
  if (errorCode === 84) {
    return (<CoveredError {...props} />);
  } else if (errorCode === 50) {
    return (<IncorrectTimeError {...props} />);
  } else if (props.errorCodeMessage === "too_far_apart") {
    return <TooFarError {...props} />;
  }

  return (<UnknownError {...props} />);
};

// TODO: move to Flow types
// SpecificErrorLayout.propTypes = {
//   errorCode: PropTypes.number
// };

export default SpecificErrorLayout;
